<script setup lang="ts">

import { apps, useOrderViewContext } from "@hantera/portal-app";
import Delivery from "@/components/Order/Deliveries/Delivery.vue";
import AppSlotView from "@/AppSlotView.vue";
import { computed } from "vue";

const orderViewContext = useOrderViewContext();

const deliveries = computed(() => {
  return [...orderViewContext.state.deliveries].sort((a, b) => {
    if (a.createdAt === b.createdAt) {
      if (a.deliveryNumber > b.deliveryNumber) {
        return -1;
      }
      if (a.deliveryNumber < b.deliveryNumber) {
        return 1;
      }
      return 0;
    }

    return b.createdAt.getTime() - a.createdAt.getTime()
  });
});

</script>

<template>

  <div class="toolbar neat-scroll">
    <AppSlotView :slot="apps.orderViewSlots.toolbars.deliveries" />
  </div>
  
  <div class="deliveries">
    <Delivery
      v-for="delivery in deliveries"
      :key="delivery.deliveryId"
      :delivery="delivery"
    />
  </div>

</template>

<style scoped>
.deliveries {
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  gap: 10px;
  margin: 10px;
  container-type: inline-size;
}
</style>